module.exports = __webpack_public_path__ + "static/media/autobookList.790cc889.svg";